import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  grid-template-areas:
    'title viewmore'
    'postlist postlist';
  row-gap: 16px;

  .post-list {
    grid-area: postlist;
  }

  .view-more {
    grid-area: viewmore;
    align-self: end;

    @media (${mediaQuery.mobile}) {
      margin-top: 16px;
    }
  }

  @media (${mediaQuery.mobile}) {
    grid-template-areas:
      'title'
      'postlist'
      'viewmore';
  }
`;
